import React from "react";
import Button from "@material-ui/core/Button";
import {Link} from 'react-router-dom'
import Typography from "@material-ui/core/Typography";
import { RemoveCircle, WatchLaterOutlined, Info, ErrorOutline } from "@material-ui/icons"
import FuseAnimate from "../fuse-animate/fuse-animate";
import red from "@material-ui/core/colors/red";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment";
import {useMediaQuery} from "@material-ui/core";
import blue from "@material-ui/core/colors/blue";
import clsx from 'clsx';


const useStyles = makeStyles((theme) => ({
    btn: {
        [theme.breakpoints.up('sm')]: {
            width: 180,
            minWidth: 180,
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    btn2: {
        [theme.breakpoints.up('md')]: {
            width: 180,
            minWidth: 180,
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
}));


// The banner is only rendered if it's conditions are met...
const AccountBanner = ({account, variant='', className, animation, delay}) => {
    const classes = useStyles();
    const isWide = useMediaQuery(theme => theme.breakpoints.up('sm'));

    // If we haven't got an account, we've got nothing to display
    if (account.id === 0) {
        return null;
    }

    const isClosed = typeof(account.closed) === 'undefined' ? false : typeof (account.closed) === 'string';

    const trialEnds = () => {
        // Set the trial end message
        let msg;
        let expiry = moment(account.trialExpiry);
        if (expiry.isBefore()) {
            msg = 'Your trial period ended ' + expiry.fromNow() + '. Upgrade now to keep your number!';
        } else {
            msg = 'Your trial period ends ' + expiry.fromNow() + '.';
        }
        return msg
    }

    switch (variant) {
        case 'suspended':
            if (account.status === 0 && !isClosed) {
                return (
                    <FuseAnimate animation={animation} delay={delay}>
                        <div className={clsx(className,"flex items-center justify-around bg-red-700 text-white MuiPaper-elevation1 rounded p-4 my-2")}>
                            <div className="flex items-center">
                                <ErrorOutline fontSize={isWide ? '' : 'large'} className={isWide ? 'pr-1' : 'pr-2'}/>
                                <Typography className="leading-tight">Your account is suspended.</Typography>
                            </div>
                        </div>
                    </FuseAnimate>
                )
            }
            return null;

        case 'pendingClosed':
            if (account.status === 0 && isClosed) {
                return (
                    <FuseAnimate animation={animation} delay={delay}>
                        <div className={clsx(className,"flex items-center justify-around bg-red-700 text-white MuiPaper-elevation1 rounded p-4 my-2")}>
                            <div className="flex items-center">
                                <WatchLaterOutlined fontSize={isWide ? '' : 'large'} className={isWide ? 'pr-1' : 'pr-2'}/>
                                <Typography className="leading-tight">This account has been closed and is waiting to be shut down.</Typography>
                            </div>
                        </div>
                    </FuseAnimate>
                )
            }
            return null;

        case 'reactivate':
            if (account.status === -1) {
                return (
                    <FuseAnimate animation={animation} delay={delay}>
                        <div className={clsx(className,"flex flex-col items-center sm:justify-between bg-white MuiPaper-elevation1 rounded p-4 my-2 sm:flex-row")}>
                            <div className="flex items-center mb-4 mt-1 sm:my-0">
                                <RemoveCircle style={{color: red[500], paddingRight: '0.25rem'}}/>
                                <Typography>Your account is closed.</Typography>
                            </div>
                            <Button className={classes.btn} color="secondary" variant="contained" component={Link} to="/reactivate">Reactivate</Button>
                        </div>
                    </FuseAnimate>
                )
            }
            return null

        case 'upgrade':
            if (account.status === 2) {
                return (
                    <FuseAnimate animation={animation} delay={delay}>
                        <div className={clsx(className,"flex flex-col items-center sm:justify-between bg-white MuiPaper-elevation1 rounded p-4 my-2 md:flex-row")}>
                            <div className="flex items-center mb-4 mt-1 md:my-0">
                                <Info fontSize="large" style={{color: blue[500]}}/>
                                <Typography className={isWide ? 'pl-1 pr-6': 'px-1'}>{trialEnds()}</Typography>
                            </div>
                            <Button className={classes.btn2} color="secondary" variant="contained" component={Link} to="/upgrade">Upgrade</Button>
                        </div>
                    </FuseAnimate>
                )
            }
            return null;

        default:
            return null;

    }

}

export default AccountBanner;